import React from 'react';
import {connect} from 'react-redux';
import ReactSelect from '../../../Shared/ReactSelect/ReactSelect';
import {changeCauseHandler} from '../IMEIDeviceRepairSlice';

const SelectCauseItem = (props) => {
  const selectedData = props.deviceRepairData.selectCauseForm.causeList[props.index] ?? {selectedCauseType: '', selectedCauseSubType: ''};
  const subOptions = props.options.find((opt) => {
    return opt.key == selectedData?.selectedCauseType;
  });

  const saveSelectedCauseType = (type, index) => {
    let causeobj = {
      name: 'selectedCauseType',
      value: type,
      rule: props.deviceRepairData.selectCauseForm.rules['selectedCauseType'],
      index: index
    }

    if(props.customChangeCauseHandler){
      props.customChangeCauseHandler(causeobj);
        }else{
        props.changeCauseHandler(causeobj);
      }
  };
  const saveSelectedSubCauseType = (type, index) => {
    let causeobj = {name: 'selectedCauseSubType',
      value: type,
      rule: props.deviceRepairData.selectCauseForm.rules['selectedCauseSubType'],
      index: index
    }
    if(props.customChangeCauseHandler){
      props.customChangeCauseHandler(causeobj);
    }else{
      props.changeCauseHandler(causeobj);
    }
  };

  return (
    <>
      <div>
        <span>סוג תקלה<span className="cellcom-color">*</span></span>
        <ReactSelect
          getOptionLabel={(option) => option.value}
          getOptionValue={(option) => option.key}
          placeholder=''
          value={props.options.filter((option) => option.key == selectedData.selectedCauseType)}
          options={props.options}
          onChange={(e) => saveSelectedCauseType(e.key, props.index)}
          error={selectedData.errors?.selectedCauseType}
        />
      </div>
      <div>
        <span>נושא<span className="cellcom-color">*</span></span>
        <ReactSelect
          getOptionLabel={(option) => option.value}
          getOptionValue={(option) => option.key}
          placeholder=''
          value={
            selectedData.selectedCauseSubType ? subOptions?.subOptions.filter((subO) => subO.key == selectedData.selectedCauseSubType) : ''
          }
          options={selectedData.selectedCauseType ? subOptions?.subOptions : ''}
          onChange={(e) => saveSelectedSubCauseType(e.key, props.index)}
          error={selectedData.errors?.selectedCauseSubType}
        />
      </div>
    </>
  );
};
const mapStateToProps = (state) => {
  return {deviceRepairData: state.iMEIDeviceRepair};
};

const mapDispatchToProps = {
  changeCauseHandler,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectCauseItem);
